import React from 'react';
import type { Product } from '../../types/product';
import { ProductCard } from './ProductCard';
import { products } from '../../data/products';
export function RelatedProducts({
  product
}: {
  product: Product;
}) {
  const same = products.filter(p => p.category === product.category && p.id !== product.id);
  const others = products.filter(p => p.category !== product.category && p.id !== product.id);
  const list = [...same, ...others].slice(0, 4);
  return <section aria-labelledby="related-heading" className="py-12" data-id="element-390" data-mp="3vgwd6jb15l2o">
      <h2 id="related-heading" className="text-xl font-bold tracking-tight text-ink sm:text-2xl" data-id="element-391" data-mp="3eet73esgsc2">
        You may also like
      </h2>
      <ul className="mt-6 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4 lg:gap-5" data-id="element-392" data-mp="3qjnwyo9fzr42">
        {list.map(p => <li key={p.id} data-id="element-393" data-mp="2a5o2hstd8to7">
            <ProductCard product={p} data-id="element-394" data-mp="2a4ctnel2cvq8" />
          </li>)}
      </ul>
    </section>;
}